import { render, staticRenderFns } from "./PayrollSelectFilter.vue?vue&type=template&id=b961c7da&scoped=true"
import script from "./PayrollSelectFilter.vue?vue&type=script&lang=ts"
export * from "./PayrollSelectFilter.vue?vue&type=script&lang=ts"
import style0 from "./PayrollSelectFilter.vue?vue&type=style&index=0&id=b961c7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b961c7da",
  null
  
)

export default component.exports